// 使用单例模式，确保 resize 监听器只添加一次
let isInitialized = false
let boundSetRem: (() => void) | null = null

export function initRem (resize = true, size = 16) {
    // utils/rem.ts
    const BASE_WIDTH = 1920 // 设计稿基准宽度
    const BASE_FONT_SIZE = size // 基准字体大小（1rem）
    const PIXEL_RATIO = window.devicePixelRatio
    
    function setRem() {
      const scale = (document.documentElement.clientWidth * PIXEL_RATIO) / BASE_WIDTH
      document.documentElement.style.fontSize = `${BASE_FONT_SIZE * Math.min(scale, 2)}px` // 限制最大缩放2倍
      
      // 电视大屏特殊处理（4K场景）
      if (window.screen.width >= 3840) {
        document.documentElement.classList.add('tv-mode')
      }
    }
    
    // 初始化执行
    setRem()
    if (resize && !isInitialized) {
      // 窗口变化时重新计算（使用单例模式，防止重复添加监听器）
      boundSetRem = setRem
      // 🔧 修复：添加 passive 选项提升滚动性能
      window.addEventListener('resize', boundSetRem, { passive: true })
      isInitialized = true
    }
}

// 提供清理方法，用于应用退出时
export function destroyRem() {
  if (boundSetRem) {
    window.removeEventListener('resize', boundSetRem)
    boundSetRem = null
    isInitialized = false
  }
}